import React from 'react';

import { useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import Image from '@atlaskit/image';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import type { AddRuleRovoPayload, DeleteRuleRovoPayload } from '@atlaskit/rovo-triggers/types';
import { token } from '@atlaskit/tokens';

import { supportedRules } from './constants';
import messages from './messages';

const styles = cssMap({
	transitionIcon: {
		width: '28px',
		height: '28px',
	},
	card: {
		width: '100%',
		paddingTop: token('space.150'),
		paddingRight: token('space.100'),
		paddingBottom: token('space.150'),
		paddingLeft: token('space.100'),
		borderStyle: 'solid',
		borderRadius: token('radius.small'),
		borderColor: token('color.border'),
		borderWidth: token('border.width'),
		backgroundColor: token('elevation.surface.raised'),
	},
});

// TODO: Add transition component for the rule that it is being added to
export const RuleAction = (
	payload: AddRuleRovoPayload | DeleteRuleRovoPayload,
): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const rule = supportedRules[payload.ruleTemplateKey];

	return (
		rule && (
			<Stack space="space.100">
				<Heading size="xsmall">{formatMessage(messages.ruleHeading)}</Heading>
				<Inline xcss={styles.card} alignBlock="start" space="space.150">
					<Image
						src={rule.icon.src}
						srcDark={rule.icon.srcDark}
						width="28px"
						height="28px"
						alt={formatMessage(rule.name)}
					/>
					<Stack>
						<Text weight="bold">{formatMessage(rule.name)}</Text>
						<Text>{payload.ruleDescription}</Text>
					</Stack>
				</Inline>
			</Stack>
		)
	);
};
